var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 595,
    viewBox: "0 0 667 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.057 41.5145C300.93 43.2176 356.437 -6.31449 408.129 12.9529C458.714 31.8079 447.648 96.6406 483.847 130.893C531.714 176.186 624.604 187.344 651.173 242.929C678.092 299.247 672.186 374.899 621.745 419.396C569.702 465.307 469.165 433.916 401.311 463.349C336.742 491.357 314.292 566.363 244.057 583.225C170.883 600.793 67.1456 604.15 21.8014 554.463C-30.4365 497.222 61.4453 409.896 26.3388 344.654C-2.52321 291.017 -132.273 300.393 -145.834 242.929C-158.329 189.985 -67.1473 159.377 -27.6232 115.992C7.00647 77.9796 17.5512 18.0641 72.8231 2.91208C129.915 -12.7388 183.82 39.7107 244.057 41.5145Z",
    fill: "#28CC9E",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondVector);
export default __webpack_public_path__ + "static/media/SecondVector.51fcca1e9aa257732a7b574c50c6a5e9.svg";
export { ForwardRef as ReactComponent };